import { ModalWrapper } from "components/common/ModalWrapper/ModalWrapper";
import React, { useState } from "react";
import { Button, Col, Row, Table } from "reactstrap";

interface IPropTypes {
  cell: {
    row: {
      original: any;
    };
  };
}

const Actions: React.FC<IPropTypes> = ({
  cell: {
    row: { original },
  },
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const formatToman = (value: number) => {
    return value.toLocaleString() + " ریال";
  };

  return (
    <>
      <div className="d-flex justify-content-center align-content-center">
        <Button
          size="sm"
          color={"warning"}
          onClick={() => setIsModalOpen(true)}
        >
          جزئیات
        </Button>
      </div>

      <ModalWrapper
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={`جزئیات تراکنش`}
      >
        <div className="mb-5">
          <Row className="mb-2">
            <Col md={6}>
              <strong>شناسه تراکنش:</strong> {original.id}
            </Col>
            <Col md={6}>
              <strong>مبلغ:</strong> {formatToman(original.amount)}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={6}>
              <strong>توضیحات:</strong> {original.description || "-"}
            </Col>
            <Col md={6}>
              <strong>وضعیت:</strong> {original.statusTitle}
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <strong>نوع تراکنش:</strong> {original.typeTitle}
            </Col>
            <Col md={6}>
              <strong>تاریخ پرداخت:</strong> {original.paymentDate}
            </Col>
          </Row>
        </div>

        <h6>اطلاعات بانکی</h6>
        <Table bordered size="sm" responsive>
          <colgroup>
            <col style={{ width: "40%" }} />
            <col style={{ width: "60%" }} />
          </colgroup>
          <tbody>
            <tr>
              <td className="pr-2">بانک/شعبه</td>
              <td className="pr-2">{original.branchName || "-"}</td>
            </tr>
            <tr>
              <td className="pr-2">کد شعبه</td>
              <td className="pr-2">{original.branchCode || "-"}</td>
            </tr>
            <tr>
              <td className="pr-2">شماره رسید</td>
              <td className="pr-2">{original.receiptNumber || "-"}</td>
            </tr>
            <tr>
              <td className="pr-2">توکن بانک</td>
              <td className="pr-2">{original.bankToken || "-"}</td>
            </tr>
            
          </tbody>
        </Table>
      </ModalWrapper>
    </>
  );
};

export { Actions };
